interface SpotlightProps {
  eyebrow?: string;
  title: string;
  description?: string;
  bullets?: string[];
  visual?: string;
  imageSrc?: string;
  imageAlt?: string;
}

export function Spotlight({
  eyebrow,
  title,
  description,
  bullets,
  visual,
  imageSrc,
  imageAlt,
}: SpotlightProps) {
  // Check if imageSrc is a video file
  const isVideo = imageSrc && /\.(mp4|webm|ogg)$/i.test(imageSrc);

  return (
    <div className="spotlight-container">
      <div className={`spotlight ${!imageSrc ? "block w-full" : ""}`}>
        <div className={!imageSrc ? "px-6" : undefined}>
          {eyebrow && <div className="spotlight__eyebrow">{eyebrow}</div>}
          <h2 className="spotlight__title">{title}</h2>
          {description && <p className="spotlight__desc">{description}</p>}
          {bullets && (
            <ul className="spotlight__bullets">
              {bullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
        </div>
        {imageSrc && (
          <div className="spotlight__visual">
            {isVideo ? (
              <video
                src={imageSrc}
                autoPlay
                loop
                muted
                playsInline
                crossOrigin="anonymous"
                className="h-full w-full object-cover"
              />
            ) : (
              <img
                src={imageSrc}
                alt={imageAlt || visual || "feature screenshot"}
                crossOrigin="anonymous"
                className="h-full w-full object-cover"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
